import { CommonState } from "../state";

import { IauiBettingLimitModalState } from "./iaui-betting-limit.model";

export namespace IauiBettingLimitSelector {
	export const isModalOpen = (state: CommonState): boolean =>
		state.commonIauiBettingLimit.modalState === IauiBettingLimitModalState.OPEN;

	export const isModalClosed = (state: CommonState): boolean =>
		state.commonIauiBettingLimit.modalState === IauiBettingLimitModalState.CLOSED;

	export const isModalShown = (state: CommonState): boolean => state.commonIauiBettingLimit.isModalShown;
}
